var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.coReqVos, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "text-contion" },
          [
            index === 0 && !_vm.disabled
              ? _c("el-button", {
                  staticClass: "btn",
                  attrs: {
                    type: "danger",
                    icon: "el-icon-plus",
                    size: "mini",
                    circle: "",
                  },
                  on: { click: _vm.addBtn },
                })
              : _vm._e(),
            index !== 0 && !_vm.disabled
              ? _c("el-button", {
                  staticClass: "btn",
                  attrs: {
                    type: "danger",
                    icon: "el-icon-minus",
                    size: "mini",
                    circle: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.deleteBtn(index)
                    },
                  },
                })
              : _vm._e(),
            _c(
              "el-form",
              {
                ref: "item",
                refInFor: true,
                attrs: { model: item, "label-width": "125px" },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c("el-form-item", { attrs: { label: "需结转组织" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "cost-select",
                              on: {
                                click: function ($event) {
                                  return _vm.openHandleClick(
                                    "org",
                                    "org_list1",
                                    "orgCode",
                                    index
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cost-select1 el-textarea el-input--small",
                                  staticStyle: { "min-height": "32px" },
                                },
                                _vm._l(
                                  item.orgReqVos,
                                  function (item1, index1) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: index1,
                                        staticClass: "tag_box",
                                        attrs: { closable: "" },
                                        on: {
                                          close: function ($event) {
                                            return _vm.handleClose(item1, index)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(item1.orgName))]
                                    )
                                  }
                                ),
                                1
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "转结财年" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  multiple: "",
                                  placeholder: "转结财年",
                                },
                                model: {
                                  value: item.coBudgetYear,
                                  callback: function ($$v) {
                                    _vm.$set(item, "coBudgetYear", $$v)
                                  },
                                  expression: "item.coBudgetYear",
                                },
                              },
                              _vm._l(_vm.fiscalYearArrList, function (item) {
                                return _c("el-option", {
                                  key: item.dictCode,
                                  attrs: {
                                    label: item.dictValue,
                                    value: item.dictCode,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "转结预算科目" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "cost-select",
                                on: {
                                  click: function ($event) {
                                    return _vm.openHandleClick(
                                      "budget",
                                      "budget_list",
                                      "budgetSubjectsCode",
                                      index
                                    )
                                  },
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    readonly: true,
                                    placeholder: "转结预算科目",
                                  },
                                  model: {
                                    value: item.coBudgetSubjectName,
                                    callback: function ($$v) {
                                      _vm.$set(item, "coBudgetSubjectName", $$v)
                                    },
                                    expression: "item.coBudgetSubjectName",
                                  },
                                }),
                                !_vm.disabled
                                  ? _c("div", { staticClass: "clear-icon" }, [
                                      _c("i", {
                                        staticClass: "el-icon-circle-close",
                                        on: {
                                          click: function ($event) {
                                            return _vm.clearFn(
                                              $event,
                                              "budget",
                                              index
                                            )
                                          },
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("el-row"),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "转结公司主体" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "cost-select",
                                on: {
                                  click: function ($event) {
                                    return _vm.openHandleClick(
                                      "company",
                                      "company_list",
                                      "companyCode",
                                      index
                                    )
                                  },
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    readonly: true,
                                    placeholder: "转结公司主体",
                                  },
                                  model: {
                                    value: item.coCompanyName,
                                    callback: function ($$v) {
                                      _vm.$set(item, "coCompanyName", $$v)
                                    },
                                    expression: "item.coCompanyName",
                                  },
                                }),
                                !_vm.disabled
                                  ? _c("div", { staticClass: "clear-icon" }, [
                                      _c("i", {
                                        staticClass: "el-icon-circle-close",
                                        on: {
                                          click: function ($event) {
                                            return _vm.clearFn(
                                              $event,
                                              "company",
                                              index
                                            )
                                          },
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c("el-form-item", { attrs: { label: "转入组织" } }, [
                          _c(
                            "div",
                            {
                              staticClass: "cost-select",
                              on: {
                                click: function ($event) {
                                  return _vm.openHandleClick(
                                    "unionOrg",
                                    "org_list2",
                                    "orgCode",
                                    index
                                  )
                                },
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: true,
                                  placeholder: "转入组织",
                                },
                                model: {
                                  value: item.unionOrgName,
                                  callback: function ($$v) {
                                    _vm.$set(item, "unionOrgName", $$v)
                                  },
                                  expression: "item.unionOrgName",
                                },
                              }),
                              !_vm.disabled
                                ? _c("div", { staticClass: "clear-icon" }, [
                                    _c("i", {
                                      staticClass: "el-icon-circle-close",
                                      on: {
                                        click: function ($event) {
                                          return _vm.clearFn(
                                            $event,
                                            "unionOrg",
                                            index
                                          )
                                        },
                                      },
                                    }),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }